export default "__VITE_ASSET__B4Y2v4BT__"